import styled from 'styled-components';

import { IconButton } from '@components/icon-button';
import { IconFile } from '@components/icons/file';
import { IconTrash } from '@components/icons/trash';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

type FileTagProps = {
  name: string;
  onRemove?: () => void;
};

export const FileTag = ({ name, onRemove }: FileTagProps) => {
  return (
    <StyledFileTag $isRemovable={Boolean(onRemove)}>
      <IconFile color="elementBlue100" size={16} />
      <Text
        font="regular12"
        text={name}
        ellipsisWithTooltip
        style={{ flex: '1 1 auto', minWidth: 0 }}
      />
      {onRemove && (
        <IconButton
          icon={<IconTrash color="buttonIconPositive" />}
          variant="ghost-purple"
          size="sm"
          onClick={onRemove}
        />
      )}
    </StyledFileTag>
  );
};

const StyledFileTag = styled(Stack).attrs({
  orientation: 'horizontal',
  space: 2,
  align: 'center',
})<{ $isRemovable: boolean }>((p) => {
  return {
    border: `1px solid ${theme.color.border10}`,
    borderRadius: pxToRem(8),
    padding: p.$isRemovable ? `${pxToRem(4)} ${pxToRem(8)}` : pxToRem(8),
    width: '100%',
    minWidth: 0,
  };
});
